<template>
  <Loader v-if="loading"></Loader>
  <div class="s-news-article--inner-padding">
    <div class="s-news-article__tabs">
      <ul class="b-tab__btn-area" role="tablist">
        <li v-for="(item, index) in tabs" :key="index" role="presentation">
          <button
            type="button"
            class="s-locations__subscription-tab-button"
            :class="showActiveTab(item)"
            :disabled="item.length == 0"
            @click="chooseTab(item)">
            {{ item.name }}
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div class="b-tab__map-content tab-pane fade active show">
    <div class="s-news-article__grid">
      <FrameCard
        v-for="card in tabContent"
        :key="card.id"
        :badge-content="card.badgeContent"
        :image="card.path"
        :instagram="card.instagram"
        :facebook="card.facebook"
        :date="card.date"
        :title="card.title"
        :href="card.cta"
        :aria-label="linkText"></FrameCard>
    </div>
    <div v-if="hasMore" class="s-news-article__cta">
      <button class="btn-secondary" type="button" @click="loadMore">
        {{ dictionary.more }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getData } from '../../lib/lib'
const {
  tabContent: records,
  dictionary,
  configuration,
} = getData('NewsTabsData')
import axios from 'axios'
import FrameCard from '../components/UI/FrameCard.vue'
import Loader from './../components/Shared/Loader.vue'
import * as lib from './../../lib/lib'
// props

// emits

// reactive data
const linkText = ref(dictionary.linkText)

const tabContent = ref([])
const tabs = ref([])
const currentTabName = ref('')
const currentTabId = ref('')

const loading = ref(true)
const hasMore = ref(true)
const currentPage = ref(0)

// hooks
onMounted(async () => {
  tabs.value = records
  currentTabName.value = tabs.value[0].name
  currentTabId.value = tabs.value[0].id
  await loadMore()
})

// methods

const showActiveTab = (tab) => {
  return currentTabName.value === tab.name ? 'active' : ''
}

const chooseTab = async (tab) => {
  currentTabName.value = tab.name
  currentTabId.value = tab.id
  currentPage.value = 0
  tabContent.value = []
  await loadMore()
}

const loadMore = async () => {
  loading.value = true
  currentPage.value += 1
  const payload = {
    page: currentPage.value,
    tab: currentTabId.value,
  }

  await axios
    .post(configuration['news-articles'], payload, lib.axiosConfig)
    .then((resp) => {
      tabContent.value.push(...resp.data.data.tabContent)
      hasMore.value = resp.data.data.hasMore
    })
    .catch((error) => {
      alert(error)
    })
  loading.value = false
}
</script>
